import type { WidgetTheme } from './types.js';

/**
 * Shared SDK-wide visual tokens.
 *
 * Applied to every widget root by default so account customizations only
 * override what they need.
 */
export const DEFAULT_WIDGET_THEME_TOKENS: WidgetTheme = {
  '--gengage-chat-offset': '20px',
  '--gengage-chat-launcher-width': '56px',
  '--gengage-chat-launcher-height': '56px',
  '--gengage-chat-width': '400px',
  '--gengage-chat-shell-radius': '1rem' /* lg roundedness */,
  '--gengage-chat-header-height': '72px',
  '--gengage-chat-conversation-width': '396px',
  '--gengage-chat-panel-min-width': '320px',
  '--gengage-chat-panel-max-width': '1200px',
  '--gengage-chat-input-height': '48px',
  '--gengage-product-card-media-ratio': '1',
  '--gengage-product-card-media-padding': '12px',
  '--gengage-product-card-mobile-media-padding': '8px',
  '--gengage-product-card-name-lines': '2',
  '--gengage-product-card-footer-margin-top': 'auto',

  '--gengage-qna-pill-radius': '999px' /* roundedness-full */,
  /** Rounded rect (not full pill) — matches `src/qna/components/qna.css` */
  '--gengage-qna-input-radius': '12px',

  '--gengage-simrel-card-radius': '0.75rem' /* md roundedness */,

  '--radius-control': '12px',
  '--radius-card': '16px',
  '--radius-panel': '24px',
  '--radius-pill': '999px',
  '--surface-card-muted': '#f8fafc',
  '--text-secondary': '#4b5563',
  '--text-muted': '#6b7280',
  '--border-default': 'rgba(17, 24, 39, 0.10)',
};

export function withDefaultWidgetTheme(theme?: WidgetTheme): WidgetTheme {
  if (!theme) {
    return { ...DEFAULT_WIDGET_THEME_TOKENS };
  }

  const mergedTheme = { ...DEFAULT_WIDGET_THEME_TOKENS, ...theme };
  const legacyLauncherSize = theme['--gengage-chat-launcher-size'];
  if (legacyLauncherSize !== undefined) {
    if (theme['--gengage-chat-launcher-width'] === undefined) {
      mergedTheme['--gengage-chat-launcher-width'] = legacyLauncherSize;
    }
    if (theme['--gengage-chat-launcher-height'] === undefined) {
      mergedTheme['--gengage-chat-launcher-height'] = legacyLauncherSize;
    }
  }

  const productMediaPadding = theme['--gengage-product-card-media-padding'];
  if (productMediaPadding !== undefined && theme['--gengage-product-card-mobile-media-padding'] === undefined) {
    mergedTheme['--gengage-product-card-mobile-media-padding'] = productMediaPadding;
  }

  return mergedTheme;
}
